import { useCallback } from 'react';

export const useBlurAll = () => {
  return useCallback(() => {
    const tmp = document.createElement('input');
    document.body.appendChild(tmp);
    tmp.focus();
    document.body.removeChild(tmp);
  }, []);
};
